import { render } from "./HomeView.vue?vue&type=template&id=8565c9f6&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=8565c9f6&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8565c9f6"],['__file',"resources/js/views/home/HomeView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8565c9f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8565c9f6', __exports__)) {
    console.log('reload')
    api.reload('8565c9f6', __exports__)
  }
  
  module.hot.accept("./HomeView.vue?vue&type=template&id=8565c9f6&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('8565c9f6', render)
  })

}


export default __exports__